// Copyright text placeholder, Warner Bros. Discovery, Inc.

import '@wbd/beam-ctv/lib/main.css';

import { bootstrapApp } from '@wbd/beam-ctv';
import { playStationAdapter } from './packlets/platform-adapter';

bootstrapApp({ platformAdapter: playStationAdapter });
